import React from 'react';
import { useNavigate } from 'react-router-dom';
import beerIcon from "../assets/page_logo.png";

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div style={{ backgroundColor: "#fff" }}>
      {/* AppBar */}
      <div
        style={{
          padding: "20px 20px",
          backgroundColor: "#F9F4EA",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            maxWidth: "1000px",
            justifyContent: "space-between",
            margin: "0 auto",
          }}
        >
          <div
            onClick={() => navigate("/")}
            style={{
              paddingTop: "5px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer", // add this so users know it's clickable
            }}
          >
            <img src={beerIcon} alt="beer icon" style={{ width: "150px" }} />
          </div>

          <button
            onClick={() => navigate("/contact")}
            style={{
              ...topHeaderButtonStyle,
              backgroundColor: "#DE810E",
              color: "white",
              marginTop: "0px",
            }}
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* Title Section */}
      <div style={{ backgroundColor: "#F9F4EA", padding: "0px 20px 130px" }}>
        <h1
          style={{
            color: "#000",
            textAlign: "center",
            margin: "0px",
            fontSize: "2rem",
          }}
        >
          Privacy Policy
        </h1>
      </div>

      {/* Main Content */}
      <div
        style={{ maxWidth: "1000px", margin: "0 auto", padding: "40px 20px" }}
      >
        <PrivacyPolicyContent />
      </div>
    </div>
  );
}

/**
 * The policy itself, word for word from the attorney's document. This page renders it, and so does
 * the Privacy Policy modal on /admin-signup, so the policy a partner agrees to is always the one
 * the site publishes. AC-PRIVACY-F2, AC-PRIVACY-F3.
 */
export function PrivacyPolicyContent() {
  const divider = (
    <hr
      style={{
        margin: "40px 0",
        border: "none",
        height: "1px",
        backgroundColor: "#DE810E",
      }}
    />
  );

  const headingStyle = {
    fontWeight: "bold",
    fontSize: "1.1rem",
    marginTop: "30px",
    marginBottom: "10px",
    color: "#333",
  };

  const bodyTextStyle = {
    fontSize: "1rem",
    lineHeight: "1.8",
    marginBottom: "15px",
    color: "#555",
  };

  return (
    <div data-testid="privacy-policy">
      <p style={{ ...headingStyle, marginTop: 0 }}>
        <strong>Effective Date:</strong> October 9, 2026
      </p>
      <p style={{ ...headingStyle, marginTop: "5px" }}>
        <strong>App Name:</strong> my HOOM
      </p>

      <p style={bodyTextStyle}>
        This Privacy Policy explains how we collect, use, disclose, and
        protect your information when you use our mobile application (the
        “App”), which enables users to purchase a beer as a gift for others.
        We are committed to protecting your personal information and your
        right to privacy.
      </p>

      <p style={bodyTextStyle}>
        If you do not agree with our policies and practices, please do not use
        the App.
      </p>

      <p style={headingStyle}>1. Information We Collect</p>
      <p style={bodyTextStyle}>
        We may collect the following types of information:
      </p>

      <p style={headingStyle}>1.1 Personal Information</p>
      <ul
        style={{
          ...bodyTextStyle,
          marginLeft: "20px",
          listStyleType: "disc",
        }}
      >
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>
          Payment information (processed securely through a third-party
          processor)
        </li>
        <li>
          Recipient’s name and contact information (email or phone number)
        </li>
        <li>Date of birth (to verify legal drinking age)</li>
      </ul>

      <p style={headingStyle}>1.2 Device & Usage Data</p>
      <ul
        style={{
          ...bodyTextStyle,
          marginLeft: "20px",
          listStyleType: "disc",
        }}
      >
        <li>IP address</li>
        <li>Device model and OS version</li>
        <li>App usage statistics</li>
        <li>Crash reports and performance data</li>
      </ul>

      <p style={headingStyle}>1.3 Location Data</p>
      <p style={bodyTextStyle}>
        If you allow location access, we may collect GPS data to help suggest
        nearby bars or participating locations for gift redemption.
      </p>

      {divider}

      <p style={headingStyle}>2. How We Use Your Information</p>
      <p style={bodyTextStyle}>We use the collected data to:</p>
      <ul
        style={{
          ...bodyTextStyle,
          marginLeft: "20px",
          listStyleType: "disc",
        }}
      >
        <li>Process transactions and deliver beer gifts</li>
        <li>Verify age and eligibility</li>
        <li>Notify gift recipients</li>
        <li>Improve user experience and App performance</li>
        <li>Send updates, confirmations, or support communications</li>
        <li>Comply with legal obligations</li>
      </ul>

      {divider}

      <p style={headingStyle}>3. Sharing of Your Information</p>
      <p style={bodyTextStyle}>
        We may share your information in the following scenarios:
      </p>
      <ul
        style={{
          ...bodyTextStyle,
          marginLeft: "20px",
          listStyleType: "disc",
        }}
      >
        <li>
          With vendors and service providers (e.g., payment processors,
          SMS/email services)
        </li>
        <li>
          With bars or establishments to facilitate the beer redemption
          process
        </li>
        <li>
          When required by law, such as to comply with a subpoena or legal
          process
        </li>
        <li>With your consent, when you choose to share or refer others</li>
      </ul>
      <p style={bodyTextStyle}>
        We do not sell your personal information to third parties.
      </p>

      <p style={headingStyle}>4. Age Restrictions</p>
      <p style={bodyTextStyle}>
        You must be 21 years or older (or the legal drinking age in your
        jurisdiction) to use this App. We do not knowingly collect personal
        data from anyone under this age.
      </p>

      {divider}

      <p style={headingStyle}>5. Security of Your Information</p>
      <p style={bodyTextStyle}>
        We implement industry-standard security measures (such as encryption
        and secure servers) to protect your data. However, no system is 100%
        secure, and we cannot guarantee absolute security.
      </p>

      <p style={headingStyle}>6. Your Rights and Choices</p>
      <p style={bodyTextStyle}>
        Depending on your location, you may have rights such as:
      </p>
      <ul
        style={{
          ...bodyTextStyle,
          marginLeft: "20px",
          listStyleType: "disc",
        }}
      >
        <li>Accessing, correcting, or deleting your personal data</li>
        <li>Opting out of marketing communications</li>
        <li>Restricting or objecting to processing</li>
      </ul>
      <p style={bodyTextStyle}>
        To make a request, please contact us at contact@myhoom.com.
      </p>

      <p style={headingStyle}>
        7. Data Retention, App Deletion, and Gift Forfeiture
      </p>
      <p style={bodyTextStyle}>
        We retain personal information for as long as needed to fulfill the
        purposes outlined in this policy, comply with our legal obligations,
        or resolve disputes, subject to the app deletion provision below.
      </p>
      <p style={bodyTextStyle}>
        If you delete the my HOOM mobile app, all personal data associated
        with your account will be removed, and all unredeemed gifted items
        associated with your account will be forfeited and will no longer be
        available for redemption.
      </p>

      {divider}

      <p style={headingStyle}>8. Third-Party Links and Services</p>
      <p style={bodyTextStyle}>
        Our App may link to third-party services (e.g., maps, partner bars).
        This policy does not apply to them. We encourage you to review their
        privacy policies separately.
      </p>

      <p style={headingStyle}>9. Changes to This Policy</p>
      <p style={bodyTextStyle}>
        We may update this Privacy Policy from time to time. Changes will be
        posted with a new effective date. Continued use of the App constitutes
        your acceptance of the revised policy.
      </p>

      {divider}

      <p style={headingStyle}>10. Contact Us</p>
      <p style={bodyTextStyle}>
        If you have any questions about this Privacy Policy, please contact
        us:
      </p>
      <p style={bodyTextStyle}>
        <strong>Email:</strong> contact@myhoom.com
      </p>
      <p style={bodyTextStyle}>
        <strong>Address:</strong> 1093 Iron Eagle Dr., Suite 115, Eagle, Idaho 83616
      </p>

      <p style={{ marginTop: "40px", fontSize: "0.95rem", color: "#888" }}>
        Last updated: October 9, 2026
      </p>
    </div>
  );
}

const topHeaderButtonStyle = {
  border: "none",
  borderRadius: "30px",
  width: "170px",
  height: "46px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "14px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

export default PrivacyPolicy;
